import * as React from 'react';
import styled from 'styled-components';

import { formatYMD } from '../../shared/dateFns';
import EventList from './EventList';

interface IProps {
    date: Date;
}

const DateHeadning = styled.h3`
    font-size: 1.35rem;
    text-indent: 3vw;
    margin-top: 0.8rem;
    margin-bottom: 0;
`;

function DateList({ date }: IProps): JSX.Element {
    return <div>
        <DateHeadning>{formatYMD(date)}</DateHeadning>
        <EventList date={date} />
    </div>;
}

export default DateList;
